.root {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.item {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  gap: 0.5rem;

  &:hover,
  &:focus-visible {
    color: var(--brand-color);
  }
}

.icon {
  color: var(--brand-color);
}
